import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackSharp } from 'react-icons/io5'; // Icon for Back button

import Room from "../../Images/JCPIC/guest.jpg";
import bill from "../../Images/payment.png";
import takeaway from "../../Images/Box Cricket.avif";

const cards = [
 
  {
    type: 'Booking',
    title: 'Booking Request',
    description: 'Check your current bookings and schedules.',
    image: Room,
    route: '/dashboard/Booking',
  },
  {
    type: 'SportsBooking',
    title: 'Sports Booking',
    description: 'View and manage your takeaway orders.',
    image: takeaway,
    route: '/Booking/sports',
  },
  {
    type: 'Payments',
    title: 'Statement Of Account',
    description: 'View and manage your payment methods.',
    image: bill,
    route: '/dashboard/Bill',
  },
];

const LinkCard = ({ showBackButton = true }) => {
  const navigate = useNavigate();

  const handleCardClick = (route) => {
    navigate(route);
  };


  return (
    <div className="container ">


      <div className="row">
        {cards.map(({ type, title, description, image, route }) => (
          <div
            key={type}
            className="col-10 col-sm-6 p-2 col-lg-4 d-flex justify-content-center "
          >
            <div
              role="button"
              tabIndex={0}
              aria-label={`${title} card`}
              className="card-custom w-70 h-70"
              style={{
                backgroundColor: '#f4f0ea',
                borderRadius: '20px',
                cursor: 'pointer',
                outline: 'none',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                maxWidth: '320px',
              }}
              onClick={() => handleCardClick(route)}
              onFocus={(e) => {
                e.currentTarget.style.outline = '3px solid #7B2E2E';
                e.currentTarget.style.outlineOffset = '2px';
              }}
              onBlur={(e) => {
                e.currentTarget.style.outline = 'none';
              }}
            >
              <img
                src={image}
                alt={title}
                className="img-fluid rounded-top"
                style={{
                  width: '100%',
                  height: '120px',
                  objectFit: 'cover',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                }}
              />
              <div className="p-1 d-flex flex-column flex-grow-1">
                <h5 className="mb-2" style={{ fontWeight: 'bold', color: '#5c4d3d' }}>
                  {title}
                </h5>
                <p
                  className="flex-grow-1"
                  style={{
                    fontSize: '0.95rem',
                    color: '#4a4a4a',
                    minHeight: '60px',
                    marginBottom: '1rem',
                  }}
                >
                  {description}
                </p>
              </div>
              <div
                className="py-2 text-center"
                style={{
                  backgroundColor: '#c8b6a6',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '1rem',
                  borderTop: '1px solid #b8a896',
                  borderBottomLeftRadius: '20px',
                  borderBottomRightRadius: '20px',
                  userSelect: 'none',
                }}
              >
                Click Here
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LinkCard;
